import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_NOVA;
  const AREAS_AMAZON = process.env.REACT_APP_AREAS_AMAZON;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_YOU;
  const AREAS_WALMART = process.env.REACT_APP_AREAS_WALMART;
  const AREAS_WALMART_NOVA = process.env.REACT_APP_AREAS_WALMART_NOVA;
  const AREAS_WALMART_DROP = process.env.REACT_APP_AREAS_WALMART_DROP;
  const AREAS_WALMART_NOVA_DROP = process.env.REACT_APP_AREAS_WALMART_NOVA_DROP;
  const AREAS_COPPEL = process.env.REACT_APP_AREAS_COPPEL;
  const AREAS_COPPEL_NOVA = process.env.REACT_APP_AREAS_COPPEL_NOVA;
  const AREAS_COPPEL_DROP = process.env.REACT_APP_AREAS_COPPEL_DROP;
  const AREAS_COPPEL_NOVA_DROP = process.env.REACT_APP_AREAS_COPPEL_NOVA_DROP;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState("");
  const [departamentoCliente, setDepartamentoCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [cliente, setCliente] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);
  const [paqueteria, setPaqueteria] = useState("");
  const [sucursal, setSucursal] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  const [paqueterias, setPaqueterias] = useState([]);
  const [selectedPaqueteria, setSelectedPaqueteria] = useState("665e148c225a1c1e3f506999");

  const [listaPrecios, setListaPrecios] = useState(1);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      precioBruto: 0,
      total: 0,
      disponible: 0,
      cliente:"NA",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [cargando, setCargando] = useState(false);

  const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      // timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    if (cargando) {
      Toast.fire({
        // html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
        html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
        title: "Cargando Disponibles....",
        customClass: {
          icon: 'animated-icon'
        }
      });
    }

  useEffect(() => {
  // Carga inicial de datos que no dependen de selectedArea
  const token = localStorage.getItem("app_token");

  const fetchAll = async () => {
    try {
      const [clientes, paqueterias, colaboradores, areas] = await Promise.all([
        axios.get(`${URL_CLIENTES}General`, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_PAQUETERIAS, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_COLABORADORES, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_AREAS, { headers: { Authorization: `Bearer: ${token}` } }),
      ]);

      setClientes(clientes.data);
      setPaqueterias(paqueterias.data);
      setColaboradores(colaboradores.data);
      setAreas(areas.data);
    } catch (err) {
      console.error("Error cargando datos iniciales:", err);
    }
  };

  fetchAll();
}, []);

useEffect(() => {
  if (cargando) {
    const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Cargando Disponibles....",
    });
  } else {
    Swal.close();
  }
}, [cargando]);

useEffect(() => {
  const token = localStorage.getItem("app_token");

  if (selectedArea) {
    setCargando(true); // Esto activa el Swal por el otro useEffect

    axios
      .get(`${URL_INVENTARIOS}DisponibleAlmacen/${selectedArea}`, {
        headers: { Authorization: `Bearer: ${token}` },
      })
      .then((res) => {
        setInventarios(res.data);
      })
      .catch((err) => {
        console.error("Error cargando inventarios:", err);
        Swal.fire("Error", "No se pudo cargar inventarios", "error");
      })
      .finally(() => {
        setCargando(false); // Esto apaga el Swal
      });
  } else {
    setInventarios([]); // Limpia inventario si no hay área
  }
}, [selectedArea]);


  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length;

    try {
      await axios
        .post(
          URL_PEDIDOS,
          {
            fecha,
            clientes: value._id,
            departamentosClientes: departamentoCliente,
            colaboradores: selectedColaborador,
            total_general: parseFloat(total_general).toFixed(2),
            observaciones,
            total_cantidad,
            paqueterias: selectedPaqueteria,
            areas: selectedArea,
            sucursales: sucursal,
            comisionTDC,
            comisionFlete,
            subTotal: parseFloat(subTotal).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            surtido: "No",
            autorizadoApartado: "Si",
            autorizadoSurtido: "Si",
            editado: "No",
            fechaModificado:fecha,
            creado: user.id,
            fecha_estimada: fecha,
            fecha_entrega: fecha,
            entregaInsumos:"No"
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad != 0) {
              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: data.data._id,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    cantidadProcesos: 0,
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio).toFixed(2),
                    precioBruto: parseFloat(a.precioBruto).toFixed(2),
                    total: parseFloat(a.total).toFixed(2),
                    autorizadoApartado: "Si",
                    autorizadoSurtido: "Si",
                    cliente: a.cliente
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Pedido",
                          detalle: `${value._id} ${total_general}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", `success`);
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      });
                  }
                });
            } else {
              totalPedido = totalPedido - 1;
              if (totalPedido == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Pedido",
                      detalle: `${value._id} ${total_general}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  });
              }
            }
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioBruto: 0,
        total: 0,
        disponible: 0,
        cliente: "NA",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * TG) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecioBruto = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.precioBruto = value;
        // let totalParcial = i.cantidad * i.precio;
        // i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = (parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)).toFixed(2);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    // if (
    //   inputFields.filter((e) => e.articulos == selectedArticulo._id).length > 0
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "El modelo ya fue capturado!",
    //     showConfirmButton: false,
    //   });
    //   const newInputFields = inputFields.map((i) => {
    //     if (id === i.id) {
    //       i.articulos = "";
    //       i.articulosNombre = "";
    //     }
    //     return i;
    //   });
    //   setInputFields(newInputFields);
    // } else {
      inventarios.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let idArticulo = a.idArticulo;
          let piezasPorCaja = a.piezasPorCaja;
          let precio;
          if (listaPrecios == 1) {
            precio = a.lista1;
          } else if (listaPrecios == 2) {
            precio = a.lista2;
          } else if (listaPrecios == 3) {
            precio = a.lista3;
          } else if (listaPrecios == 4) {
            precio = a.lista4;
          }
          let precioBruto;
          if (listaPrecios == 1) {
            precioBruto = a.lista1Bruto;
            // precioBruto = a.lista1;
          } else if (listaPrecios == 2) {
            // precioBruto = a.lista2;
            precioBruto = a.lista2Bruto;
          } else if (listaPrecios == 3) {
            // precioBruto = a.lista3;
            precioBruto = a.lista3Bruto;
          } else if (listaPrecios == 4) {
            // precioBruto = a.lista4;
            precioBruto = a.lista4Bruto;
          }
          let articulosNombre =  a.SKU + " " + a.nombre;
          let disponible = a.disponible;
          handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, precioBruto, articulosNombre, disponible);
        }
      });
    // }
  }

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio, precioBruto, articulosNombre, disponible) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precioBruto = precioBruto;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.disponible = disponible;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * TG) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  }

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = inventarios.map((option) => {
    const junta = option.SKU + " " + option.ASIN + " " + option.nombre;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaCliente(selectedCliente) {
    setValue(selectedCliente);

    axios
      .get(`${URL_CLIENTES}/${selectedCliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;

        setCliente(allCliente);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id)
        setListaPrecios(allCliente.listaPrecios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SUCURSALES}/clientes/${selectedCliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaSucursal(value) {
    let split = value.split(",");
    let dir = split[0];

    setSelectedSucursal(value);
    setSucursal(dir);
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal +
        parseFloat(e) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(e)
    );
  }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }
  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los SKU de los artículos a sus objetos correspondientes
        const articulosMap = {};
        inventarios.forEach((articulo) => {
          articulosMap[articulo.SKU] = articulo;
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const articulo = articulosMap[a.SKU];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              articulosNombre: articulo.SKU + " " +  articulo.nombre,
              piezasPorCaja: 0,
              cajas: 0,
              cantidad: a.Unidades,
              precio: parseFloat((a.Precio / a.Unidades).toFixed(2)),
              precioBruto: a.PrecioBruto,
              total: a.Precio,
              disponible: 0,
              cliente: a.Comprador || "NA",
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.SKU);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes SKU no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }
// console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Pedido</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Cliente</Label>
              <Autocomplete
                size="small"
                value={value}
                onChange={(event, selectedCliente) => {
                  jalaCliente(selectedCliente);
                }}
                options={options.sort(
                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                )}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.junta}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona"
                    variant="outlined"
                  />
                )}
                renderOption={(option) => (
                  <React.Fragment>
                    {option.codigo} {option.nombre_comercial}
                  </React.Fragment>
                )}
              />
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                type="select"
                value={selectedColaborador}
                // onChange={(e) => {
                //   setSelectedColaborador(e.target.value)
                // }}
                disabled
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label>Sucursal</Label>
              <Input
                type="select"
                value={selectedSucursal}
                onChange={(e) => {
                  jalaSucursal(e.target.value);
                }}
              >
                <option value="">Selecciona una Sucursal</option>
                {sucursales
                  .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                  .map((a) => {
                    if (a.is_active == "Si") {
                      return <option value={[a._id]}>{a.alias}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Paqueteria</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedPaqueteria}
                required
                onChange={(e) => {
                  setSelectedPaqueteria(e.target.value);
                }}
              >
                <option value="0">Selecciona </option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Surtir de Almacen</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                  setCargando(true);
                  setInventarios([]);
                  setInputFields([
                    {
                      id: uuidv4(),
                      articulos: "",
                      articulosNombre: "",
                      piezasPorCaja: 0,
                      cajas: 0,
                      cantidad: 0,
                      precio: 0,
                      precioBruto: 0,
                      total: 0,
                      disponible: 0,
                      cliente: "NA",
                    },
                  ]);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .filter(
                    (a) =>
                      ![
                        AREAS_AMAZON,
                        AREAS_AMAZON_YOU,
                        AREAS_MELI,
                        AREAS_MELI_NOVA,
                        AREAS_WALMART,
                        AREAS_WALMART_NOVA,
                        AREAS_COPPEL,
                        AREAS_COPPEL_NOVA,
                      ].includes(a._id)
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={1}>
              <Label>Comision TDC</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionTDC}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionTDC(value);
                }}
              />
            </Col> */}
            {/* <Col md={1}>
              <Label>Comision Flete</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionFlete}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionFlete(value);
                }}
              />
            </Col> */}

            <Col md={1}>
              <Label>Impuestos %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={selectedImpuesto}
                onChange={(e) => {
                  calculaImpuesto(e.target.value);
                }}
              />
            </Col>

            <Col md={1}>
              <Label>Sub Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={subTotal}
                disabled
                className={`form-control`}
              />
            </Col>
            <Col md={1}>
              <Label>IVA</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={iva}
                disabled
                className={`form-control`}
              />
            </Col>

            <Col md={1}>
              <Label>Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={total_general}
                disabled
                className={`form-control`}
              />
            </Col>

            <Col md={1}>
              <Label>Piezas</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas"
                value={total_cantidad}
                required
                disabled
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={1}>
              <Label></Label>
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={(e) => toggleCambiaPrecio()}
              >
                Cambiar Precio <i class="fas fa-dollar-sign"></i>
              </Button>
            </Col> */}
          </Row>
          <br />
          {/* <Row>
            <Col md={3}>
              <Label>Archivo</Label>
              <Input
                type="file"
                name="file"
                id="file"
                disabled={inventarios.length === 0}
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
          </Row> */}
          {/* Tabla Articulos */}

          {/* <Form className={classes.root}> */}
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Buscador</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Disponible</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cliente</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Cajas</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Piezas Por Caja</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio Bruto</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={inputField.articulosNombre}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticulo(inputField.id, selectedArticulo);
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.SKU} {option.ASIN} {option.nombre}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  {/* <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="">Selecciona un Articulo</option>
                    {articulos
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre}
                          </option>
                        );
                      })}
                  </Input> */}
                  <Input
                    name="articulo"
                    type="string"
                    placeholder="Articulo"
                    value={inputField.articulosNombre}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    type="number"
                    disabled
                    value={inputField.disponible}
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cliente"
                    type="string"
                    value={inputField.cliente}
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  ></Input>
                </Col>

                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cajas"
                    type="number"
                    value={inputField.cajas}
                    onChange={(event) =>
                      handleChangeInputCajas(inputField.id, event)
                    }
                  ></Input>
                </Col> */}
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="piezasPorCaja"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.piezasPorCaja}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputCantidad(inputField.id, event)
                    }
                  />
                </Col>
                {user.cambiaPrecios ? (
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="precio"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.precio}
                      className={`form-control-md2`}
                      onValueChange={(value, name) =>
                        handleChangeInputPrecio(value, name, inputField.id)
                      }
                    />
                  </Col>
                ) : cambiarPrecio ? (
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="precio"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.precio}
                      className={`form-control-md2`}
                      onValueChange={(value, name) =>
                        handleChangeInputPrecio(value, name, inputField.id)
                      }
                    />
                  </Col>
                ) : (
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="precio"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.precio}
                      className={`form-control-md2`}
                      disabled
                    />
                  </Col>
                )}
                <Col md={1}>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    name="precio"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={inputField.precioBruto}
                    className={`form-control-md2`}
                    onValueChange={(value, name) =>
                      handleChangeInputPrecioBruto(value, name, inputField.id)
                    }
                  />
                </Col>
                <Col md={1}>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={inputField.total}
                    disabled
                    className={`form-control-md2-disabled`}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    // tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          {/* </Form> */}
          {/* Termina Tabla Articulos */}
          <br />
          <Row>
            <Col md={1}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoPedidos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Cambio de Precio</h4>
            </ModalHeader>
            <ModalBody>
              <Input
                // bsSize="sm"
                type="password"
                placeholder="Password"
                value={password}
                required
                onChange={(event) => setPassword(event.target.value)}
              />
              <br />
              <Row>
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => autorizaCambio()}
                  >
                    Autorizar
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
